import WidgetRepository from '@/src/api/WidgetRepository'

import { AnalysisAPI } from './AnalysisAPI'
import { AutocompleteAPI } from './Autocomplete'
import { BillingRepository } from './BillingRepository'
import { ClipsRepository } from './ClipsRepository'
import { detectIntelligenceRepository } from './DetectIntelligenceRepository'
import { EditVoiceRepository } from './EditVoiceRepository'
import { HistoryRepository } from './HistoryRepository'
import { OnboardingRepository } from './OnboardingRepository'
import { PhonemeRepository } from './PhonemeRepository'
import { PlaygroundRepository } from './PlaygroundRepository'
import { PresetRepository } from './PresetRepository'
import { ProjectRepository } from './ProjectRepository'
import { RecordingsRepository } from './RecordingsRepository'
import { speechTranscriptRepository } from './SpeechTranscriptRepository'
import { TeamsRepository, updateWindowUserData } from './TeamsRepository'
import { TermSubstitutionRepository } from './TermSubstitutionRepository'
import { VoiceRepository } from './VoiceRepository'

export const recordingsRepository = new RecordingsRepository()
export const termSubstitutionRepository = new TermSubstitutionRepository()
export const phonemeRepository = new PhonemeRepository()
export const clipsRepository = new ClipsRepository()
export const analysisAPI = new AnalysisAPI()
export const presetRepository = new PresetRepository()
export const autocompleteAPI = new AutocompleteAPI()
export const voicesRepository = new VoiceRepository()
export const widgetsRepository = new WidgetRepository()
export const playgroundRepository = new PlaygroundRepository()
export const projectRepository = new ProjectRepository()
export const onboardingRepository = new OnboardingRepository()
export const billingRepository = new BillingRepository()
export const editVoiceRepository = new EditVoiceRepository()
export const historyRepository = new HistoryRepository()
export { speechTranscriptRepository }
export { detectIntelligenceRepository }
export const teamsRepository = new TeamsRepository()
export { updateWindowUserData }
